'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _eventQueue = require('./eventQueue');

var _eventQueue2 = _interopRequireDefault(_eventQueue);

var _eventemitter = require('eventemitter3');

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _eventMarker = require('./eventMarker');

var _eventMarker2 = _interopRequireDefault(_eventMarker);

var _dataTrackEventExtractor = require('./dataTrackEventExtractor');

var _dataTrackEventExtractor2 = _interopRequireDefault(_dataTrackEventExtractor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var _instance = null;
var eventEmitter = new _eventemitter2.default();

var Eventd = function () {
  _createClass(Eventd, null, [{
    key: 'mark',
    value: function mark(name) {
      _instance.marker.mark(name);
    }
  }, {
    key: 'measure',
    value: function measure(name, properties) {
      return _instance.marker.measure(name, properties);
    }
  }, {
    key: 'event',
    value: function event(_event, properties, callback) {
      var eventData = {
        event: _event,
        properties: properties
      };

      if (callback) {
        eventData.callback = callback;
      }

      _instance.queue.push(eventData);
    }
  }, {
    key: 'resetConfig',
    value: function resetConfig() {
      Eventd.instance.clientName = undefined;
      Eventd.instance.disabled = true;
      Eventd.instance.debugMode = false;
      Eventd.instance.controllerName = 'unknown';
      Eventd.instance.controllerAction = 'unknown';
      Eventd.instance.eventUrl = null;
    }
  }, {
    key: 'resetQueue',
    value: function resetQueue() {
      Eventd.instance.queue = new _eventQueue2.default(this, eventEmitter);
    }
  }, {
    key: 'handleDataTrackClick',
    value: function handleDataTrackClick(event) {
      var _DataTrackEventExtrac = (0, _dataTrackEventExtractor2.default)(event),
          name = _DataTrackEventExtrac.name,
          properties = _DataTrackEventExtrac.properties;

      Eventd.event(name, properties);
    }
  }, {
    key: 'setListeners',
    value: function setListeners() {
      var delegated = require('delegated-events');

      var on = delegated.on;
      on('click', '[data-track]', Eventd.handleDataTrackClick);
    }
  }, {
    key: 'instance',
    get: function get() {
      if (!_instance) {
        return new Eventd();
      }

      return _instance;
    }
  }, {
    key: 'clientName',
    get: function get() {
      return this.instance.clientName;
    },
    set: function set(name) {
      this.instance.clientName = name;
    }
  }, {
    key: 'disabled',
    get: function get() {
      return this.instance.disabled;
    },
    set: function set(boolean) {
      this.instance.disabled = boolean;

      if (!boolean) {
        eventEmitter.emit('eventd-enabled');
      }
    }
  }, {
    key: 'controllerName',
    get: function get() {
      return this.instance.controllerName;
    },
    set: function set(name) {
      this.instance.controllerName = name;
    }
  }, {
    key: 'controllerAction',
    get: function get() {
      return this.instance.controllerAction;
    },
    set: function set(name) {
      this.instance.controllerAction = name;
    }
  }, {
    key: 'eventUrl',
    get: function get() {
      return this.instance.eventUrl;
    },
    set: function set(url) {
      this.instance.eventUrl = url;
    }
  }, {
    key: 'queueLength',
    get: function get() {
      return _instance.queue.length;
    }
  }, {
    key: 'debugMode',
    set: function set(enabled) {
      return _instance.debugMode = enabled;
    },
    get: function get() {
      return _instance.debugMode;
    }
  }]);

  function Eventd() {
    _classCallCheck(this, Eventd);

    if (!_instance) {
      _instance = this;
      _instance.queue = new _eventQueue2.default(this, eventEmitter);
      _instance.marker = new _eventMarker2.default(_instance.queue);
    }

    Eventd.resetConfig();

    if (typeof window !== 'undefined') {
      Eventd.setListeners();
    }

    return _instance;
  }

  return Eventd;
}();

exports.default = Eventd;